<template>
    <div :class="labelClasses" :style="labelStyles">
        <strong v-if="component.style && component.style.fontWeight === 'bold'">
            <div :contenteditable="isEditable" :class="wrapClass"
                 @blur="onEditEnd"
                 v-text="getLabelValue">
            </div>
        </strong>
        <div v-else :class="wrapClass"
             :contenteditable="isEditable"
             @blur="onEditEnd"
             v-text="getLabelValue">
        </div>
    </div>
</template>

<script>
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'LabelRenderer',
        props: ['component', 'labelValue', 'containerWidth', 'layout'],
        data() {
            return {
                model: webase.model
            }
        },
        computed: {
            getLabelValue() {
                return this.labelValue ? this.labelValue : this.component.value
            },

            labelClasses() {
                return `${this.marginClasses} ${this.paddingClasses} ${this.colorClass} ${this.sizeClasses} ${this.wrapClass} ${this.textAlignClasses}`.trim()
            },

            wrapClass() {
                if(this.isEditable) {
                    return ''
                }

                if(this.component.style.nowrap) {
                    return 'truncated-label'
                }

                return ''
            },

            labelStyles() {
                let styles = `${this.colorStyle} ${this.maxWidthStyle}`

                if(this.component.style.nowrap && this.containerWidth && this.containerWidth > 0) {
                    styles += ` width: ${this.containerWidth}px`
                }

                return styles
            },

            marginClasses() {
                if (!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },

            paddingClasses() {
                if (!this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },

            colorStyle() {
                if (this.isCustomColor) {
                    return `color: ${this.component.style.color};`
                }

                return ''
            },

            maxWidthStyle() {
                if (!this.component.style.maxWidth) {
                    return ''
                }

                return `max-width: ${this.component.style.maxWidth}px;`
            },

            colorClass() {
                if(this.layout.theme_id) {
                    return ''
                }


                if (this.component.style && this.component.style.color && this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0) {
                    return `text-${this.component.style.color}`
                }

                return ''
            },

            isCustomColor() {
                return webase.utils.ui.isCustomColor(this.component)
            },

            sizeClasses() {
                if (!this.component.style.size) {
                    return ''
                }

                return `${this.component.style.size}`
            },

            textAlignClasses() {
                if (!this.component.style.align) {
                    return ''
                }

                return `${this.component.style.align}`
            },

            isEditable() {
                if (this.$router) {
                    let routeName = this.$router.currentRoute.name
                    return routeName === 'view-editor' || routeName === 'page-editor' || routeName === 'layout-editor'
                }

                return false
            }
        },
        mounted() {
            if (!this.component.style) {
                this.component.style = {
                    color: 'dark',
                    align: 'text-left'
                }
            }

            if (!this.component.style.align) {
                this.component.style.align = 'text-left'
            }

            if (!this.component.animation) {
                this.component.animation = new PageFactory().defaultAnimation()
            }
        },
        methods: {
            onEditEnd(event) {
                if(event.target.innerText) {
                    this.component.value = event.target.innerText
                }
            }
        }
    }
</script>
